// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Samoa */
const WS = /^(?:(?:7[1-35-8]|8(?:[3-7]|9\d{3}))\d{5})$/;

export default WS;
